// extracted by mini-css-extract-plugin
export default {"container":"UMsR9","containerExtraSpacing":"vDqdj"};